import {
	IconButton,
	Input,
	InputGroup,
	InputProps,
	InputRightElement,
} from "@chakra-ui/react";
import React, { forwardRef } from "react";
import "react-day-picker/dist/style.css";
import { useTranslatedString } from "src/i18n/hooks";
import { Calendar } from "src/icons";

export type DatePickerInputProps = {
	inputProps?: InputProps;
	isOpen: boolean;
	onOpen: () => void;
	value: string;
};

export const DatePickerInput = forwardRef<
	HTMLInputElement,
	DatePickerInputProps
>(({ inputProps, isOpen, onOpen, value }, ref) => {
	const t = useTranslatedString();

	return (
		<InputGroup>
			<Input
				{...inputProps}
				ref={ref}
				onClick={onOpen}
				placeholder={inputProps?.placeholder ?? value}
				value={value}
				cursor="pointer"
				readOnly
			/>

			<InputRightElement>
				<IconButton
					variant="link"
					aria-label={
						isOpen ? t("datepicker.close") : t("datepicker.open")
					}
					icon={
						<Calendar
							w={4.5}
							h={4.5}
							fillRule="evenodd"
							color="brand.blue"
						/>
					}
					onClick={onOpen}
					id="click_open_datepicker"
				/>
			</InputRightElement>
		</InputGroup>
	);
});

DatePickerInput.displayName = "DatePickerInput";

// 🔬 e2e: contact.spec.ts
